import React, {useEffect} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {useHistory} from 'react-router-dom'
import CrearUsuario from './Components/CrearUsuario'
import {useDispatch, useSelector} from 'react-redux'
import {
  gu_cu_ChangePage,
  gu_cu_Clear,
} from '../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {State} from '../../../reducers'
import ModalsControls from './modals/ModalsControls'

const CrearUsuarioIndex = () => {
  const page = useSelector((state: State) => state.gestionUsuario.creacionUsuario.paginaActual)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    window.scroll(0, 0)
    return () => {
      dispatch(gu_cu_Clear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
  }, [page])

  const back = () => {
    if (page > 0) dispatch(gu_cu_ChangePage(-1))
    else history.goBack()
  }

  return (
    <BasicLayout>
      <ModalsControls />
      <div
        id='w-node-_37c4edc4-e645-30b8-cee7-f036e602dada-04e476cd'
        className='w-layout-cell w-100'
      >
        <div className='header'>
          <button className='back-button w-inline-block' onClick={back}></button>
          <h3 className='h3-titles xl'>Crear usuario</h3>
        </div>
        <div className='separador'></div>
        <CrearUsuario />
      </div>
    </BasicLayout>
  )
}

export default CrearUsuarioIndex
